var mixin = {
  data () {
    return {
      pageSizeOpts: [20, 30, 50]
    }
  }
}

export default {
  mixin
}
